import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import '@cloudscape-design/global-styles/index.css';
import App from './App';
import awsExports from './aws-exports.json';

// Suppress benign ResizeObserver loop error (common with CloudScape tables + drawers)
// See: https://github.com/WICG/resize-observer/issues/38
// Use capture phase to intercept before webpack-dev-server's error overlay
window.addEventListener(
  'error',
  (e: ErrorEvent) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true, // capture phase — fires before overlay handlers
);

// Configure Amplify
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: awsExports['OD1-Cognito'].UserPoolId,
      userPoolClientId: awsExports['OD1-Cognito'].UserPoolClientId,
      identityPoolId: awsExports['OD1-Cognito'].IdentityPoolId,
      loginWith: {
        oauth: {
          domain: `${awsExports['OD1-Cognito'].UserPoolDomainPrefix}.auth.us-east-1.amazoncognito.com`,
          scopes: ['openid', 'profile', 'aws.cognito.signin.user.admin'] as [
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: [window.location.origin] as [string],
          redirectSignOut: [window.location.origin] as [string],
          responseType: 'code' as 'code',
        },
      },
    },
  },
};

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
